/*
* 2022年9月21日14:10:00 LXC
* 格式化共用方法
* */
import Vue from 'vue';
import self from '@/common/utils/global-config';
import '../../../public/js/date';
import * as Constants from '@/common/utils/constants';

/*
* 由生日格式化年龄
* 可以通过格式为 yyyy-MM-dd 的生日计算出年龄
* birthday[string]：格式为 yyyy-MM-dd 的生日
* */
export function ageByBirthday(birthday) {
  if (self.$sn.validate.empty(birthday)) {
    return -1;
  }
  let age;
  const date = birthday.split('-');
  const birthdayYear = parseInt(date[0]);
  const birthdayMonth = parseInt(date[1]);
  const birthdayDay = parseInt(date[2]);
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const currentDay = new Date().getDay();
  if (birthdayYear === currentYear) {
    age = 0;
  }
  else {
    const gapYear = currentYear - birthdayYear;
    if (gapYear > 0) {
      if (birthdayMonth === currentMonth) {
        const gapDay = currentDay - birthdayDay;
        if (gapDay < 0) {
          age = gapYear - 1;
        }
        else {
          age = gapYear;
        }
      }
      else {
        const gapMonth = currentMonth - birthdayMonth;
        if (gapMonth < 0) {
          age = gapYear - 1;
        }
        else {
          age = gapYear;
        }
      }
    }
    else {
      age = -1;
    }
  }
  return age;
}

/*
* 由身份证号格式化生日
* 将传入的身份证号处理为 yyyy-MM-dd 格式的生日返回
* idCardSerial[string]：身份证号字符串
* */
export function birthdayByIdCardSerial(idCardSerial) {
  if (self.$sn.validate.empty(idCardSerial) && !self.$sn.validate.idCardSerial(idCardSerial)) {
    return '';
  }
  return idCardSerial.substring(6, 10) + '-' + idCardSerial.substring(10, 12) + '-' + idCardSerial.substring(12, 14);
}

/*
* 格式化替换字符串信息
* 通过此方法可以对字符串中的值在不同使用场景中进行替换，可以应用于 swagger 地址中的入参、messages 提示信息替换、温馨提示文案的替换等
* title[string]：文案字符串，需要替换的项按照顺序，以数组的角标和大括号来进行编号
* info[array]：替换数据的数组，数组中每一项的顺序与 title 中顺序相对应
* */
export function caption(title, info) {
  if (self.$sn.validate.empty(title)) {
    return '';
  }
  let caption = title;
  if (info.length > 0) {
    for (let i = 0; i < info.length; i++) {
      if (!self.$sn.validate.empty(info[i])) {
        caption = caption.replace('{' + i.toString() + '}', info[i]);
      }
    }
  }
  return caption;
}

/*
证件名称文案
type[string]：证件标识
 */
export function certificateTitle(type) {
  if (self.$sn.validate.empty(type)) {
    return '身份证';
  }
  if (type === '0') {
    return '身份证';
  }
  else if (type === '1') {
    return '护照';
  }
  else if (type === '2') {
    return '台胞证';
  }
  else if (type === '3') {
    return self.$sn.getConfig('foreignerPermanentResidencePermitRename');
  }
  else if (type === '4') {
    return '港澳通行证';
  }
}

export function clone(obj) {
  if ([null, undefined, NaN, false].includes(obj)) return obj;
  if (typeof obj !== 'object' && typeof obj !== 'function') return obj;
  const o = self.$sn.validate.array(obj) ? [] : {};
  for (const i in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, i)) {
      o[i] = typeof obj[i] === 'object' ? clone(obj[i]) : obj[i];
    }
  }
  return o;
}

/*
* 格式化日期
* 可以对日期进行文案的格式化处理，例如“yyyy年MM月dd日”转换为“yyyy-MM-dd”
* 对于需要在目标日期上进行年、月、周、日、时、分、秒增减处理，例如想获取“2022-06-15”昨天的日期“2022-06-14”
* 由于在引入三方插件后，date.js 函数文件使用会失效，则提供此方法对日期进行格式化处理
* time[date]：中国标准时间
* type[string]：格式化后的样例，eg：yyyy-MM-dd
* extra[integer]：在目标日期的基础上递增或递减的基准值，此字段必须为整数；正数则为递增，负数则为递减
* standard[string]：递增或递减的单位；year：年，month：月，week：周，day：日，hour：时，minute：分，second：秒，millisecond：毫秒
* */
export function date(time, type, extra, standard) {
  if (self.$sn.validate.empty(time) || self.$sn.validate.empty(type)) {
    return '';
  }
  let func = '';
  if (['year', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'].includes(standard) && !self.$sn.validate.empty(extra) && self.$sn.validate.integer(Math.abs(extra))) {
    func = 'add' + standard.substring(0, 1).toUpperCase() + standard.substr(1) + 's';
  }
  if (!self.$sn.validate.empty(func)) {
    return Date.parse(time)[func](extra).toString(type);
  }
  else {
    return Date.parse(time).toString(type);
  }
}

/*
* 日期转换为周几
* 将传入的日期转换为周几，方便各页面使用直接进行展示
* value[string]：待转换的日期字符串
* */
export function day(value) {
  if (!value && !self.$sn.validate.date(value)) {
    return '';
  }
  const figure = new Date(value).getDay();
  if (figure === 0) {
    return '日';
  }
  else if (figure === 1) {
    return '一';
  }
  else if (figure === 2) {
    return '二';
  }
  else if (figure === 3) {
    return '三';
  }
  else if (figure === 4) {
    return '四';
  }
  else if (figure === 5) {
    return '五';
  }
  else if (figure === 6) {
    return '六';
  }
}

/*
* 数组排序
* 可以通过此方法对目标数组根据需求来进行排序
* digital[array]：待排序数组
* type[string]：排序方式，默认为升序；1：升序，2：降序
* sort[string]：排序字段名称，默认为“sort”
* */
export function digitalSort(digital, type = '1', sort = 'sort') {
  if (self.$sn.validate.empty(digital) || digital.length === 0) {
    return [];
  }
  const compare = {
    '1': -1,
    '2': 1
  };
  const verify = !self.$sn.validate.empty(sort) && Object.prototype.hasOwnProperty.call(digital[0], sort);
  return digital.sort(function(val1, val2) {
    let value1 = '';
    let value2 = '';
    if (verify) {
      value1 = self.$sn.validate.integer(val1[sort]) ? parseInt(val1[sort]) : val1[sort];
      value2 = self.$sn.validate.integer(val2[sort]) ? parseInt(val2[sort]) : val2[sort];
    }
    else {
      value1 = val1;
      value2 = val2;
    }
    if (value1 < value2) return compare[type];
    if (value1 > value2) return compare[type] * -1;
    return 0;
  });
}

export function getQuality(target, key) {
  if (self.$sn.validate.empty(target) || !self.$sn.validate.object(target)) return '';
  if (self.$sn.validate.empty(key) || !self.$sn.validate.string(key)) return '';
  if (key.indexOf('.') === -1) return target[key];
  else {
    const digital = key.split('.');
    let initial = target[digital[0]] || {};
    for (let i = 1; i < digital.length; i++) {
      if (initial) initial = initial[digital[i]];
    }
    return initial;
  }
}

export function group(variable, len) {
  if (!self.$sn.validate.array(variable) || !self.$sn.validate.integer(len)) return variable;
  let i;
  let j;
  const transfer = [];
  for (i = 0, j = variable.length; i < j; i += len) {
    transfer.push(variable.slice(i, i + len));
  }
  return transfer;
}

export function guid(len = 32, prefix = true, radix = null) {
  const standard = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const uuid = [];
  radix = radix || standard.length;
  if (len) {
    for (let i = 0; i < len; i++) uuid[i] = standard[0 | Math.random() * radix];
  }
  else {
    let r;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';
    for (let i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16;
        uuid[i] = standard[(i === 19) ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  if (prefix) {
    uuid.shift();
    return `u${uuid.join('')}`;
  }
  return uuid.join('');
}

/*
* 格式化包含 HTML 标签字符串
* 部分业务场景中，返回的信息都会带有 HTML 标签，在详情页需要进行富文本展示；
* 而在前置页面中会出现展示部分信息的情况，例如医生擅长在医生主页只展示两行信息，而在医生介绍展示全部信息。则在展示部分信息时，需要使用此方法将 HTML 标签删除
* html[string]
* */
export function html(html) {
  if (self.$sn.validate.empty(html)) {
    return '';
  }
  return html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, '').trim();
}

export function merge(target = {}, source = {}) {
  target = clone(target);
  if (typeof target !== 'object' || typeof source !== 'object') return false;
  for (const prop in source) {
    if (!Object.prototype.hasOwnProperty.call(source, prop)) continue;
    if (prop in target) {
      if (typeof target[prop] !== 'object') {
        target[prop] = source[prop];
      }
      else if (typeof source[prop] !== 'object') {
        target[prop] = source[prop];
      }
      else if (target[prop].concat && source[prop].concat) {
        target[prop] = target[prop].concat(source[prop]);
      }
      else {
        target[prop] = merge(target[prop], source[prop]);
      }
    }
    else target[prop] = source[prop];
  }
  return target;
}

/*
将数字转换为汉字
variable[string/integer]：待转换数字
type[string]：0：不使用大写汉字；1：使用大写汉字
sep[string]：如存在小数点后数字时，整数部分单位，默认为“元”
gather[array]：小数点后单位集合，默认为角、分
*/
export function nToC(variable, type = '0', sep, gather) {
  if (!self.$sn.validate.number(variable) && !self.$sn.validate.string(variable)) return '';
  variable = variable.toString();
  if (self.$sn.validate.empty(variable)) return '';
  const basic = {
    '0': {
      'caption': ['', '一', '二', '三', '四', '五', '六', '七', '八', '九'],
      'unit': ['', '十', '百', '千', '万', '十万', '百万', '千万', '亿']
    },
    '1': {
      'caption': ['', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'],
      'unit': ['', '拾', '佰', '仟', '万', '拾万', '佰万', '仟万', '亿']
    }
  };
  const compare = basic[type] || basic['0'];
  let integer = variable.split('.')[0];
  let decimal = '';
  if (variable.split('.').length === 2) decimal = variable.split('.')[1];
  let secretary = '';
  integer = integer.split('').reverse();
  for (let i = 0; i < integer.length; i++) {
    const n = integer[i];
    const u = compare.unit[i];
    if (n === '0') {
      // 如连续多个零，则只保留一个零
      if (secretary[0] === '零') secretary = secretary.substring(1);
      // 如不是最末尾为零，则添加一个零 or 当前只有一个个位数为零
      if ((integer.length > 1 && i !== 0) || integer.length === 1) {
        secretary = '零' + secretary;
      }
      continue;
    }
    secretary = compare.caption[n] + u + secretary;
  }
  if (decimal) {
    if (self.$sn.validate.empty(sep)) sep = '元';
    secretary = secretary + sep;
    if (self.$sn.validate.empty(gather)) gather = ['', '角', '分'];
    else gather = ['', ...gather];
    decimal = decimal.split('');
    for (let i = 0; i < decimal.length; i++) {
      const n = decimal[i];
      if (n === '0') continue;
      secretary = secretary + compare.caption[n] + gather[n];
    }
  }
  return secretary;
}

/*
就诊卡名称文案
type[string]：就诊卡标识
 */
export function outCardTitle(type) {
  let title = '';
  if (type === '1') {
    title = '就诊卡';
  }
  else if (type === '2') {
    title = '省医保';
  }
  else if (type === '3') {
    title = '社保卡';
  }
  else if (type === '4') {
    title = '市医保';
  }
  else if (type === '5') {
    title = '身份证';
  }
  else if (type === '6') {
    title = '电子健康卡';
  }
  else {
    title = '卡号';
  }
  return title;
}

/*
* 格式化平台名称
* 通过各平台主键，来格式化各平台名称
* type[string]：待格式化名称的平台主键，默认为当前平台
* */
export function platformTitle(type = self.$sn.utils.getPlatformType()) {
  const title = {
    [Constants.PLATFORM_TYPE_WECHAT_MINI]: '微信小程序',
    [Constants.PLATFORM_TYPE_ALIPAY_MINI]: '支付宝小程序',
    [Constants.PLATFORM_TYPE_BAIDU_MINI]: '百度小程序',
    [Constants.PLATFORM_TYPE_WECHAT_H5]: '微信公众号',
    [Constants.PLATFORM_TYPE_ALIPAY_H5]: '支付宝生活号',
    [Constants.PLATFORM_TYPE_WECHAT_CITY]: '微信城市服务',
    [Constants.PLATFORM_TYPE_ALIPAY_CITY]: '支付宝城市服务',
    [Constants.PLATFORM_TYPE_PC]: '官网预约'
  };
  return title[type];
}

/*
* 前置使用“0”补全
* 应用于需使用“0”来进行信息补全的场景
* digital[string]：待补全信息
* n[integer]：补全后信息长度
* */
export function prefixCompleteZero(digital, n) {
  const value = Array(n).join(0) + digital;
  return value.slice(-n);
}

/*
* 对数值形式的金额进行格式化
* number[string/integer]：需要格式化的金额数值
* decimals[integer]：格式化后小数点的位数，默认为0
* decimalPoint[string]：小数点的符号，默认为.
* thousandsSeparator[string]：千分位分隔符，默认为英文逗号,
* */
export function priceFormat(number, decimals = 0, decimalPoint = '.', thousandsSeparator = ',') {
  const boundaryCheckingState = true;
  // 四舍五入
  const round = (num, ratio) => {
    const base = Math.pow(10, ratio);
    let result = divide(Math.round(Math.abs(times(num, base))), base);
    if (num < 0 && result !== 0) {
      result = times(result, -1);
    }
    return result;
  };
  // 高精度乘法
  const times = (...num) => {
    if (num.length > 2) {
      return iteratorOperation(num, times);
    }
    const [num1, num2] = num;
    const num1Changed = float2Fixed(num1);
    const num2Changed = float2Fixed(num2);
    const base = digitLength(num1) + digitLength(num2);
    const left = num1Changed * num2Changed;
    verifyBoundary(left);
    return left / Math.pow(10, base);
  };
  // 高精度除法
  const divide = (...num) => {
    if (num.length > 2) {
      return iteratorOperation(num, divide);
    }
    const [num1, num2] = num;
    const num1Changed = float2Fixed(num1);
    const num2Changed = float2Fixed(num2);
    verifyBoundary(num1Changed);
    verifyBoundary(num2Changed);
    // 使用 strip 进行修正
    return times(num1Changed / num2Changed, strip(Math.pow(10, digitLength(num2) - digitLength(num1))));
  };
  /*
  递归操作扁平迭代化
  arr[array]：待操作的数字数组
  operation[function]：迭代操作
  */
  const iteratorOperation = (arr, operation) => {
    const [num1, num2, ...others] = arr;
    let result = operation(num1, num2);
    others.forEach(num => {
      result = operation(result, num);
    });
    return result;
  };
  // 把小数转成整数，如果是小数则放大成整数
  const float2Fixed = (num) => {
    if (num.toString().indexOf('e') === -1) {
      return Number(num.toString().replace('.', ''));
    }
    const len = digitLength(num);
    return len > 0 ? strip(Number(num) * Math.pow(10, len)) : Number(num);
  };
  // 检测数字是否越界，如果越界给出提示
  const verifyBoundary = (num) => {
    if (boundaryCheckingState) {
      if (num > Number.MAX_SAFE_INTEGER || num < Number.MIN_SAFE_INTEGER) {
        console.warn(`${num}超出了精度限制，结果可能不正确。`);
      }
    }
  };
  const digitLength = (num) => {
    const e = num.toString().split(/[eE]/);
    const len = (e[0].split('.')[1] || '').length - +(e[1] || 0);
    return len > 0 ? len : 0;
  };
  // 修正错误数据
  const strip = (num, precision = 15) => {
    return +parseFloat(Number(num).toPrecision(precision));
  };
  if (self.$sn.validate.empty(number)) return '';
  number = (`${number}`).replace(/[^0-9+-Ee.]/g, '');
  const n = !isFinite(+number) ? 0 : +number;
  const pre = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  const dec = (typeof decimalPoint === 'undefined') ? '.' : decimalPoint;
  const sep = (typeof thousandsSeparator === 'undefined') ? ',' : thousandsSeparator;
  let s = '';
  s = (pre ? round(n, pre) + '' : `${Math.round(n)}`).split('.');
  const re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, `$1${sep}$2`);
  }
  if ((s[1] || '').length < pre) {
    s[1] = s[1] || '';
    s[1] += new Array(pre - s[1].length + 1).join('0');
  }
  return s.join(dec);
}

/*
与本人关系
type[string]：关系标识
 */
export function relation(type) {
  if (!type) {
    return '';
  }
  const digital = {
    '0': '本人',
    '1': '父母',
    '2': '子女',
    '3': '其他',
    '4': '夫妻',
    '5': '朋友'
  };
  return digital[type] ? digital[type] : '';
}

/*
* 对象转 URL 参数
* digital[object]：所需处理的信息
* prefix[boolean]：前缀是否为 ?
* format[string]：当数据某一项的值为数据时的处理方式：repeat，comma，brackets，indices；样例参照下方批注
* */
export function reverseObjectParameter(digital, prefix = true, format = 'repeat', empty = true) {
  if (typeof digital === 'object') {
    let url = '';
    Object.keys(digital).forEach(el => {
      if (!empty || !['', undefined, null].includes(digital[el])) {
        /*
        * 如所需处理的信息为数组，则提供4种处理方式，由 format 来决定，以下批注样例为
        * {
        *   title: ['first', 'secondary']
        * }
        * */
        if (typeof digital[el] === 'object') {
          // 格式化后为 &title=first&title=secondary
          if (format === 'repeat') {
            digital[el].forEach(element => {
              url += '&' + el + '=' + element;
            });
          }
          // 格式化后为 &title=first,secondary
          else if (format === 'comma') {
            url += '&' + el + '=' + digital[el].join(',');
          }
          // 格式化后为 &title[]=first&title[]=secondary
          else if (format === 'brackets') {
            digital[el].forEach(element => {
              url += '&' + el + '[]=' + element;
            });
          }
          // 格式化后为 &title[0]=first&title[1]=secondary
          else if (format === 'indices') {
            digital[el].forEach((element, index) => {
              url += '&' + el + '[' + index.toString() + ']=' + element;
            });
          }
        }
        else {
          url += '&' + el + '=' + digital[el];
        }
      }
    });
    if (prefix) {
      url = url.replace('&', '?');
    }
    return url;
  }
  else {
    return '';
  }
}

/*
* URL 参数转对象
* 可以通过此方法将 URL 参数转换为对象，方面各业务页面接收后可以直接进行数据处理
* url[string]：待转换的 URL 参数字符串
* */
export function reverseUrlParameter(url) {
  const info = {};
  if (!self.$sn.validate.empty(url)) {
    url = url.replace('?', '').split('&');
    url.forEach(el => {
      Vue.set(info, el.split('=')[0], el.split('=')[1]);
    });
  }
  return info;
}

/*
* 富文本样式处理
* 主要应用于支付宝小程序，处理只用u-parse组件时，给 DOM 定义类选择器时样式不生效的情况
* text[string]：富文本字符串
* style[string]：外层 DOM 待定义的类选择器类名
* tag[string]：外层 DOM 使用的标签名称；uni-app 框架默认为 view，H5 框架默认为 div
* */
export function richText(text, style, tag = 'div') {
  if (self.$sn.validate.empty(text)) {
    return '';
  }
  if (self.$sn.validate.empty(style)) {
    return text;
  }
  return '<' + tag + ' class="' + style + '">' + text + '</' + tag + '>';
}

export function setQuality(target, key, value) {
  const repeat = function(tar, digit, val) {
    if (digit.length === 1) {
      tar[digit[0]] = val;
      return;
    }
    while (digit.length > 1) {
      const k = digit[0];
      if (self.$sn.validate.empty(tar[k]) || !self.$sn.validate.object(tar[k])) tar[k] = {};
      digit.shift();
      repeat(tar[k], digit, val);
    }
  };
  if (!self.$sn.validate.object(target)) return;
  if (self.$sn.validate.empty(key) || !self.$sn.validate.string(key)) {}
  if (key.indexOf('.') === -1) target[key] = value;
  else {
    repeat(target, key.split('.'), value);
  }
}

/*
性别
type[string]：性别标识
 */
export function sex(type) {
  let value = '未知';
  if (type === '1' || type === 1) {
    value = '男';
  }
  else if (type === '2' || type === 2) {
    value = '女';
  }
  return value;
}

/*
由身份证号格式化性别
1：男；2：女；3：其它
idCardSerial[string]：身份证号字符串
 */
export function sexByIdCardSerial(idCardSerial) {
  if (self.$sn.validate.empty(idCardSerial) || !self.$sn.validate.idCardSerial(idCardSerial)) {
    return '3';
  }
  return parseInt(idCardSerial.slice(-2, -1)) % 2 === 1 ? '1' : '2';
}

/*
* 对象格式信息转换为 XML 格式
* 将对象格式的信息转换为 XML 格式
* info[object]：待格式化的信息
* empty[boolean]：当 info 中某项信息为空时，是否仍进行 XML 拼接
* */
export function xml(info, empty = false) {
  if (self.$sn.validate.empty(info) || !self.$sn.validate.object(info)) {
    return '';
  }
  let xml = '<Request>';
  const k = Object.keys(info);
  const v = Object.values(info);
  for (let i = 0; i < k.length; i++) {
    if (v[i] || empty) {
      xml += '<' + k[i] + '>';
      xml += v[i] ? v[i] : '';
      xml += '</' + k[i] + '>';
    }
  }
  xml += '</Request>';
  return xml;
}

/*
由时差格式化日期
因本地设备处于不同时区导致的时差问题
time[date]：标准时间
 */
export function zone(time) {
  // 如果不在北京时区，则进行转换
  if (new Date().getTimezoneOffset() !== -480) {
    // 返回格林威治时间和本地时间之间的时差
    const offset = new Date().getTimezoneOffset() * 60 * 1000;
    const target = 480 * 60 * 1000;
    // 备忘：格林威治时间 = 本地时间 + 时差
    const jab = time.getTime() + offset + target;
    return new Date(jab);
  }
  else {
    return time;
  }
}
